/**
 * br-reforma-about-c-hero — donor entrance sequence and video control.
 *
 * Re-implements the Reforma about-c Webflow actions in vanilla JS.
 * Hidden state is JS-armed only, so content stays visible without JS.
 * The donor hides its video at <=991; our mapped <=900 layout pauses it.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const compactLayout = window.matchMedia('(max-width: 900px)');

  const setup = (section) => {
    if (section.dataset.brReformaAboutCHeroReady === 'true') return;
    section.dataset.brReformaAboutCHeroReady = 'true';

    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      section.classList.add('br-reforma-about-c-hero--armed');

      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          section.classList.remove('br-reforma-about-c-hero--armed');
          observer.disconnect();
        }
      });

      observer.observe(section);
    }

    const video = section.querySelector('.br-reforma-about-c-hero__video');
    const toggle = section.querySelector('[data-br-reforma-about-c-video-toggle]');
    if (!video || !toggle) return;

    const pauseIcon = toggle.querySelector('[data-br-reforma-about-c-pause]');
    const playIcon = toggle.querySelector('[data-br-reforma-about-c-play]');
    const labels = {
      play: toggle.dataset.labelPlay,
      pause: toggle.dataset.labelPause,
    };
    let userPaused = false;

    const syncControl = () => {
      const paused = video.paused;
      pauseIcon.hidden = paused;
      playIcon.hidden = !paused;
      toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');

      if (labels.play && labels.pause) {
        toggle.setAttribute('aria-label', paused ? labels.play : labels.pause);
      }
    };

    const syncPlayback = () => {
      if (reducedMotion.matches || compactLayout.matches || userPaused) {
        video.pause();
      } else {
        video.play().catch(() => {
          syncControl();
        });
      }

      syncControl();
    };

    toggle.addEventListener('click', () => {
      if (video.paused) {
        userPaused = false;
        video.play().catch(() => {
          syncControl();
        });
      } else {
        userPaused = true;
        video.pause();
      }
    });

    video.addEventListener('play', syncControl);
    video.addEventListener('pause', syncControl);
    reducedMotion.addEventListener('change', syncPlayback);
    compactLayout.addEventListener('change', syncPlayback);
    // Sources are deferred (data-src): they attach only at >=901px on
    // approach, then syncPlayback starts playback. Below that the video is
    // display:none and nothing downloads.
    window.brVideoDefer?.attach(video, { minWidth: 901, onAttached: syncPlayback });
    syncPlayback();
  };

  document.querySelectorAll('[data-br-reforma-about-c-hero]').forEach(setup);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-br-reforma-about-c-hero]').forEach(setup);
  });
})();
